var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('OrderListItem',{key:item.bill_code,attrs:{"data":item}})}))}
var staticRenderFns = []

export { render, staticRenderFns }